import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalObservables } from '../../../../../app.global.observer';
import { HelperService } from '../../../services/helper.service';
import { Global } from '../../../../../app.global';
import { KeyDescriptionViewModel } from '../../../viewmodels/keyDescriptionViewModel';

import { ContraventionQuestionModel } from '../../../viewmodels/policy-item.model';
import { StoppingPassengersCopy } from '../../../helper/textcopy/policies.text';
import { ReportsService } from '../../../services/reports.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'stopping-passengers-policy',
  templateUrl: './stopping-passengers.component.html',
})
export class StoppingPassengersComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSavePolicies = new EventEmitter();
  policiesAnswersSetted = new Subscription();
  policiesAnswers: any = this.global.policiesAnswers;

  textCopy = StoppingPassengersCopy;
  contraventions = new ContraventionQuestionModel();

  constructor(
    public global: Global,
    private globalObs: GlobalObservables,
    private helpServ: HelperService,
    private reportsService: ReportsService
  ) {}

  ngOnInit() {
    this.setContraventionsQuestion();

    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.onPoliciesAnswersSetted();
    } else {
      this.setSelectedValues();
    }
  }

  setContraventionsQuestion() {
    this.contraventions.options = [
      { value: 'y', text: 'Y' },
      { value: 'n', text: 'N' },
      { value: 'q', text: 'Q' },
    ];
  }
  onContraventionsSelected(answerValue) {
    this.contraventions.valuesSelected = answerValue;
    this.contraventions.valuesSelected = this.contraventions.valuesSelected.slice();
  }

  setSelectedContraventions() {
    this.reportsService.getOffences().subscribe((result) => {
      this.contraventions.valuesSelected = [];
      result.forEach((contravention) => {
        // no contravention 15 and 77 for policies
        if (contravention.id === 15 || contravention.id === 77) {
          return;
        }
        const value = this.policiesAnswers[`28_1_${contravention.id}`];
        this.contraventions.valuesSelected.push({
          id: contravention.id,
          value: value !== undefined ? value : 'n',
        });
      });
    });
  }

  setSelectedValues() {
    this.setSelectedContraventions();
  }

  onPoliciesAnswersSetted() {
    this.policiesAnswers = this.global.policiesAnswers;
    this.policiesAnswersSetted = this.globalObs.onPoliciesAnswersSetted.subscribe(() => {
      this.setSelectedValues();
    });
  }

  submitPolicyCategory() {
    let policyList = new Array<KeyDescriptionViewModel>();
    policyList = [];

    this.contraventions.valuesSelected.forEach((contravention, index) => {
      policyList.push({ id: `28_1_${contravention['id']}`, description: contravention['value'] });
    });
    this.onSavePolicies.emit(policyList);
  }

  ngOnDestroy() {
    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.policiesAnswersSetted.unsubscribe();
    }
  }
}
